export const formatToQA = (value) => value.replace(/\s/g, '_');
